import './ResultStep.scss';

import React from 'react';

import Alert, { AlertType } from '../../../../../common/Alert';
import bem from '../../../../../utils/bem';
import CustomPacingScheduleHeader from '../CustomPacingScheduleHeader';
import { useCustomPacingScheduleContext } from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import DefaultContentWrapper from '../DefaultContentWrapper/DefaultContentWrapper';
import ResultInfo from './ResultInfo/ResultInfo';
import { mapSaveScheduleResultToResultInfoProps } from './utils';

const [block, element] = bem('result-step');

const ERROR_ALERT_MESSAGE = 'Something went wrong during saving Custom Pacing schedule. Please try later.';

const CONFIRM_BUTTON_TEXT = 'Go To Line Items';

const ResultStep = (): React.JSX.Element => {
  const { savedScheduleResult, onClose } = useCustomPacingScheduleContext();

  const resultInfoProps = savedScheduleResult ? mapSaveScheduleResultToResultInfoProps(savedScheduleResult) : null;

  return (
    <div>
      <CustomPacingScheduleHeader customConfirmText={CONFIRM_BUTTON_TEXT} onConfirm={onClose} />
      <DefaultContentWrapper>
        <div data-testid="result-step" className={block()}>
          {resultInfoProps ? (
            <ResultInfo {...resultInfoProps}></ResultInfo>
          ) : (
            <Alert className={element('error')} type={AlertType.ERROR} bodyText={ERROR_ALERT_MESSAGE} />
          )}
        </div>
      </DefaultContentWrapper>
    </div>
  );
};
export default ResultStep;
